<template>
    <button @click="$emit('clicked')" :class="{'customClass' : !customPosition}" v-if="show">
        <i class="fal fa-plus" />
    </button>
</template>
<script>
export default {
    name: 'FloatingButton',

    props: {
        customPosition: {
            default: false,
        },

        show: {
            default: true,
            required: false,
            type: Boolean,
        },
    },
};
</script>
<style lang="scss" scoped>
button {
    border: 0px solid transparent;
    width: 80px;
    height: 80px;
    border-radius: 80px;
    // position: absolute;
    // right: 40px;
    // bottom: 90px;
    background-color: $yellow;
    color: $black;
    cursor: pointer;

    i {
        font-size: 40px;
        color: $black;
    }
}

.customClass {
    position: absolute;
    right: 40px;
    bottom: 90px;
}
</style>
